<script setup lang="ts">
import { computed } from 'vue';

import { getHHMMFormatFromMinutes } from '@apps/main/modules/helpers/formatting';

import { getCssCustomPropertyValue, getStringStyles } from '@libs/ui';

import type { TravelDurationFormatterData } from './TravelDurationFormatter.model';

interface TravelDurationFormatterProps {
  data: TravelDurationFormatterData;
}

const props = defineProps<TravelDurationFormatterProps>();

const style = computed(() =>
  getStringStyles(props.data.color, getCssCustomPropertyValue)
);

const label = computed(() => getHHMMFormatFromMinutes(props.data.value));
</script>

<template>
  <span :class="[props.data.font]" :style="style">
    {{ label }}
  </span>
</template>
